export const CRM_DOCUMENT_PATH = "/crm/documents/:documentId";
